import { CenterEmailType } from '@nkr/store/index'
import { FormEvent } from 'react';
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    emailType: CenterEmailType,
    historyCompletedDays: number,
    onFieldChange: (name: string, value: any) => void,
    onSubmit: () => void,
    onCancel: () => void
}

const OptionsModal = (props: IProps) => {
    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        props.onFieldChange(name, value);
    };

    let title = '';

    if (props.emailType == CenterEmailType.MicrositeDailySummary) {
        title = 'Microsite Daily Summary';
    }

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Options for {title}
            </Modal.Header>
            <Modal.Body>
                <Form horizontal>
                    {props.emailType == CenterEmailType.MicrositeDailySummary && (
                        <>
                            <FormGroup>
                                <Col xs={12} lg={4} componentClass={ControlLabel}>History Completed Days:</Col>
                                <Col xs={12} lg={5}>
                                    <FormControl
                                        name='historyCompletedDays'
                                        value={props.historyCompletedDays}
                                        onChange={handleFieldChange} />
                                </Col>
                            </FormGroup>
                        </>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onSubmit}>Submit</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OptionsModal;